import React, { createContext, useContext, useEffect, useState } from "react";
import { createPortal } from "react-dom";

const WorkspaceActiveContext = createContext(false);

export function WorkspaceActiveProvider({ active, children }) {
  return (
    <WorkspaceActiveContext.Provider value={Boolean(active)}>
      {children}
    </WorkspaceActiveContext.Provider>
  );
}

export function NavigationSlotPortal({ layer, children }) {
  const active = useContext(WorkspaceActiveContext);
  const [target, setTarget] = useState(null);

  useEffect(() => {
    if (!active) {
      setTarget(null);
      return;
    }
    const id = layer === 2
      ? "mazboy-navigation-layer-2"
      : "mazboy-navigation-layer-3";
    setTarget(document.getElementById(id));
  }, [active, layer]);

  if (!active || !target) return null;
  return createPortal(children, target);
}
